function Unauthorized() {
    return (
        <div>
            <header>Unauthorized!!</header>
        </div>
    );
}

export default Unauthorized;
